import React, { Component } from 'react'
import { Card, CardBody, CardHeader, Button, Alert } from 'reactstrap'
import { Link } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import {connect} from 'react-redux';
import districtAdmin from '../../helpers/users/testing/districtAdmin'
import {
  Email,
  ErrorMessage,
  FirstName,
  LastName,
  Username,
  PasswordReset,
  State,
  SaveButton,
} from './NewManageUsers/ManagePane/InfoCard/ActionBlockComponents'
import validateFields from '../../helpers/users/manageUsers/validateFields';
import saveChanges from '../../helpers/users/manageUsers/saveChanges';
import devMode from '../../config/devMode'
import {authingUserSuccess} from './../../redux/modules/users'

class UserProfileEdit extends Component {

  state = {
    firstName: this.props.user.firstName || '',
    lastName: this.props.user.lastName || '',
    username: this.props.user.username || '',
    email: this.props.user.email || '',
    changed: false,
    saving: false,
    error: '',
    saved: false,
    validation: {},
  }

  oChg = ({target}) => {
    let validation = {...this.state.validation}
    if (validation[target.name]) {
      validation = {}
    }
    this.setState({[target.name]: target.value, changed: true, saved: false, validation})
  }

  oSave = () => {
    const { user } = this.props
    const { firstName, lastName, username, email } = this.state
    this.setState({saving: true, error: ''}) 
    const validationErr = validateFields(this.props.user, this.state,)
    if (validationErr) {
      this.setState({validation: validationErr, saving: false})
    } else {
      const data = { firstName, lastName, username, email, }
      saveChanges(user, data)
        .then(() => {this.setState({
          saved: true, 
          changed: false, 
          saving: false, 
          error: '', 
          validation: {}
        })
      
      user.firstName = firstName;
      user.lastName = lastName;
      user.email = email;
      user.username = username;
      this.props.authingUserSuccess(user)
      }
        
        
        
        )
        .catch(err => {
          console.log(err)
          const errorMessage = (
            err === 'Email or username already in use.' || 
            err === 'No changes to save.' 
            ? err 
            : 'Error saving changes.'
          )
          this.setState({saving: false, error: errorMessage})
        })
    }
  }

  render() {
   
    const user = devMode ? this.props.user || districtAdmin : this.props.user
    if (!user) return null

    const { role } = user
    let {
      firstName,
      lastName,
      username,
      email,
      saving,
      changed,
      saved,
      validation,
      error,
    } = this.state 

    return (
      <Card>
        <CardHeader>Edit Profile</CardHeader>
        <CardBody>
        <div className="input-group-wrap">
          <h5>Edit Your Information Below:</h5>
          <FirstName oChg={this.oChg} val={firstName} err={validation} />
          <LastName oChg={this.oChg} val={lastName} err={validation} />
          {role === 'Student' && <Username oChg={this.oChg} val={username} err={validation}/>}
          <Email oChg={this.oChg} val={email} err={validation} />
          </div>
          <div className="profile-btns">
          <SaveButton changed={changed} oSave={this.oSave}>
          {saving 
            ? <BeatLoader loading={saving} /> 
            : (saved ? 'Saved' : 'Save')
          }
          </SaveButton>
          </div>
          {Object.keys(validation).length > 0
            ? <Alert color="warning" className="mt-3">{validation[Object.keys(validation)[0]]}</Alert>
            : null
          }
          {error
            ? <Alert color="warning" className="mt-3">{error}</Alert>
            : null
          }
          <div className="back-to-profile" className="mt-3"><Link to='/profile'>{`< Return to Profile`}</Link></div>
        </CardBody>
      </Card>
    )
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
    authingUserSuccess : (user) => {dispatch(authingUserSuccess(user))}
  }
}
export default connect(
  (state) => ({
    user: state.users.testUser,
  })
)(UserProfileEdit)


// WEBPACK FOOTER //
// ./src/components/Users/UserProfileEdit.js